import i18n from "i18next";

function changeLanguage(lng) {
  i18n.changeLanguage(lng);
}

export { changeLanguage };
